import React, { useState, useEffect } from "react";
import { fetchItems } from "../api";
import MICLogo from "../pages/main/pic/MICLogo.png";

export default function SlideShow() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    fetchItems().then((all) => setItems(all.filter((i) => i.visible)));
  }, []);
  const slides = items.map((item) => item.text);

  //   const slides = [
  //     "Welcome to the slideshow",
  //     "This is slide number two",
  //     "React makes UI easy",
  //     "You can put any text here",
  //     "Slides change every 15 seconds",
  //   ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5000); // 5 seconds
    // 15000); // 15 seconds
    // 10000); // 10 seconds
    return () => clearInterval(timer);
  }, [slides.length]);

  const containerStyle = {
    margin: " auto",
    padding: "auto",
    width: "95%",
    height: "97vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // border: "1px solid #ccc",
    // borderRadius: "8px",
    fontSize: "24px",
    fontWeight: "bold",
    transition: "opacity 0.5s ease",
    // padding: "20px",
    backgroundColor: "#C4DAD2",
    textAlign: "center",
  };

  return (
    <div>
      {/* <h2>React Text Slideshow</h2> */}
      <div style={containerStyle}>
        <h2 style={{ fontSize: "50px" }}>{slides[index]}</h2>
        <img
          src={MICLogo}
          className="icon-image rotate-360"
          alt="Left Icon"
          style={{
            height: 80,
            width: 80,
            position: "fixed",
            bottom: "22px",
            right: "55px",
            zIndex: 100, // No quotes for numerical values
            width: "100px",
            height: "auto",
          }}
        />
      </div>

      <style>
        {`
      @import url(https://fonts.googleapis.com/css?family=Roboto:400,500);
@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css);
*, *:before, *:after {
  box-sizing: border-box;
}

html, body {
//   height: 100%;
}

body {
  color: #444;
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
  line-height: 1.5;
}

.slider {
  height: 100%;
  position: relative;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-flow: row nowrap;
      -ms-flex-flow: row nowrap;
          flex-flow: row nowrap;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
      -ms-flex-align: end;
          align-items: flex-end;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
      -ms-flex-pack: center;
          justify-content: center;
}

@keyframes check {
  50% {
    outline-color: #333;
    box-shadow: 0 0 0 12px #333, 0 0 0 36px rgba(51, 51, 51, 0.2);
  }
  100% {
    outline-color: #333;
    box-shadow: 0 0 0 0 #333, 0 0 0 0 rgba(51, 51, 51, 0);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg); /* Start at 0 degrees */
  }
  100% {
    transform: rotate(360deg); /* End at 360 degrees */
  }
}

/* Apply the animation to the image class */
.rotate-360 {
  animation: spin 15s linear infinite;
  /* 
    animation values:
    - spin: name of the @keyframes animation
    - 3s: duration of one rotation (3 seconds)
    - linear: animation timing function (constant speed)
    - infinite: animation iteration count (runs forever)
  */
  display: inline-block; /* Helps with centering if needed */
}

`}
      </style>
    </div>
  );
}
